(function () {
    "use strict";

    angular.module("sempraWebapp").controller("SavingsCreateController", SavingsCreateController);

    /** @ngInject */
    function SavingsCreateController(
        $scope,
        $state,
        $timeout,
        $translate,
        layoutActions,
        savingsActions,
        userActions,
        pricingActions
    ) {
        var vm = this;

        // Sale types dropdown options - will include packages after loading
        vm.saleTypes = [];
        vm.selectedSaleType = null;
        vm.defaultValidityDays = 365; // Will be loaded from company

        // Form data
        vm.savingsPackages = [];
        vm.customAmount = null;
        vm.customPrice = null;
        vm.validFrom = new Date();
        vm.validityDays = 365; // Default, will be loaded from company
        vm.validTo = new Date(new Date().setDate(new Date().getDate() + 365));
        vm.minDate = new Date();

        // State
        vm.isLoading = false;
        vm.isCreating = false;
        vm.companyDetails = null;
        vm.currency = 'EUR';

        // Functions
        vm.onSaleTypeChange = onSaleTypeChange;
        vm.onPackageSelect = onPackageSelect;
        vm.onCustomAmountChange = onCustomAmountChange;
        vm.onValidFromChange = onValidFromChange;
        vm.onValidityDaysChange = onValidityDaysChange;
        vm.onValidToChange = onValidToChange;
        vm.createSavingsAccount = createSavingsAccount;
        vm.goBack = goBack;
        vm.getTotalAmount = getTotalAmount;
        vm.getPrice = getPrice;

        // Print
        vm.savingsForPrint = [];

        init();

        function init() {
            $scope.$on("$destroy", onDestroyHandler);
            loadData();
        }

        function onDestroyHandler() {
            vm.savingsPackages = [];
            vm.selectedPackage = null;
        }

        function loadData() {
            vm.isLoading = true;
            
            // Load company details
            userActions.getCompanyDetails().then(
                function(companyData) {
                    vm.companyDetails = companyData;
                    if (companyData) {
                        // Load savings expiration days from company
                        if (companyData.savingsExpirationDays) {
                            vm.defaultValidityDays = companyData.savingsExpirationDays;
                            vm.validityDays = companyData.savingsExpirationDays;
                            updateValidTo();
                        }
                        // Load currency
                        if (companyData.region && companyData.region.currencyCode) {
                            vm.currency = companyData.region.currencyCode;
                        }
                    }
                    loadSavingsPackages();
                },
                function(error) {
                    console.error('Error loading company details:', error);
                    loadSavingsPackages();
                }
            );
        }

        function loadSavingsPackages() {
            pricingActions.getCompanySavingsPackages().then(
                function(response) {
                    vm.savingsPackages = response || [];
                    buildSaleTypesList();
                    vm.isLoading = false;
                },
                function() {
                    vm.savingsPackages = [];
                    buildSaleTypesList();
                    vm.isLoading = false;
                }
            );
        }

        function buildSaleTypesList() {
            // Start with Regular option
            vm.saleTypes = [
                { value: 'REGULAR', label: $translate.instant('SAVINGS_SALE_TYPE_REGULAR'), isPackage: false, isPostpaid: false, package: null },
                { value: 'POSTPAID', label: $translate.instant('SAVINGS_SALE_TYPE_POSTPAID'), isPackage: false, isPostpaid: true, package: null }
            ];
            
            // Add each package as a sale type option
            if (vm.savingsPackages && vm.savingsPackages.length > 0) {
                vm.savingsPackages.forEach(function(pkg) {
                    vm.saleTypes.push({
                        value: 'PACKAGE_' + pkg.id,
                        label: pkg.name + ' - ' + pkg.credit.amount.toFixed(2) + ' ' + pkg.credit.code,
                        isPackage: true,
                        isPostpaid: false,
                        package: pkg
                    });
                });
            }
            
            // Set default to Regular
            vm.selectedSaleType = vm.saleTypes[0];
        }

        function onSaleTypeChange() {
            if (vm.selectedSaleType.isPackage && vm.selectedSaleType.package) {
                // Package selected - use package validity if available
                if (vm.selectedSaleType.package.validity) {
                    vm.validityDays = vm.selectedSaleType.package.validity;
                } else {
                    vm.validityDays = vm.defaultValidityDays;
                }
            } else {
                // Regular selected - reset to default validity days
                vm.validityDays = vm.defaultValidityDays;
            }
            updateValidTo();
        }

        function onPackageSelect() {
            // No longer needed - packages are selected via sale type dropdown
        }

        function onCustomAmountChange() {
            // Auto-fill price with the same value as credit amount
            vm.customPrice = vm.customAmount;
        }

        function onValidFromChange() {
            updateValidTo();
        }

        function onValidityDaysChange() {
            if (vm.validityDays > 0) {
                updateValidTo();
            }
        }

        function onValidToChange() {
            if (vm.validFrom && vm.validTo) {
                var diffTime = vm.validTo.getTime() - vm.validFrom.getTime();
                var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                vm.validityDays = diffDays > 0 ? diffDays : 1;
            }
        }

        function updateValidTo() {
            if (vm.validFrom && vm.validityDays > 0) {
                var newValidTo = new Date(vm.validFrom);
                newValidTo.setDate(newValidTo.getDate() + vm.validityDays);
                vm.validTo = newValidTo;
            }
        }

        function getTotalAmount() {
            if (vm.selectedSaleType && vm.selectedSaleType.isPackage && vm.selectedSaleType.package) {
                return vm.selectedSaleType.package.credit ? vm.selectedSaleType.package.credit.amount : 0;
            }
            return vm.customAmount || 0;
        }

        function getPrice() {
            if (vm.selectedSaleType && vm.selectedSaleType.isPackage && vm.selectedSaleType.package) {
                return vm.selectedSaleType.package.price ? vm.selectedSaleType.package.price.amount : 0;
            }
            return vm.customPrice || 0;
        }

        function createSavingsAccount() {
            if (!validateForm()) {
                return;
            }

            vm.isCreating = true;
            layoutActions.showLoader();

            var saleType = 'REGULAR';
            if (vm.selectedSaleType.isPostpaid) {
                saleType = 'POSTPAID';
            } else if (vm.selectedSaleType.isPackage) {
                saleType = 'PACKAGE';
            }

            var savingsData = {
                saleType: saleType,
                postpaid: vm.selectedSaleType.isPostpaid,
                packageId: vm.selectedSaleType.isPackage && vm.selectedSaleType.package ? vm.selectedSaleType.package.id : null,
                amount: vm.selectedSaleType.isPostpaid ? 0 : getTotalAmount(),
                currency: vm.currency,
                validFrom: vm.validFrom,
                validTo: vm.validTo,
                validityDays: vm.validityDays
            };

            savingsActions.createSavingsAccount(savingsData).then(
                function(response) {
                    vm.isCreating = false;
                    layoutActions.hideLoader();
                    
                    // Prepare for print
                    vm.savingsForPrint = [response];
                    
                    // Print the savings account
                    $timeout(function() {
                        window.print();
                    }, 100);
                },
                function(error) {
                    vm.isCreating = false;
                    layoutActions.hideLoader();
                    console.error('Error creating savings account:', error);
                }
            );
        }

        function validateForm() {
            if (!vm.selectedSaleType) {
                return false;
            }
            // Postpaid doesn't require amount
            if (!vm.selectedSaleType.isPostpaid && !vm.selectedSaleType.isPackage && (!vm.customAmount || vm.customAmount <= 0)) {
                return false;
            }
            if (!vm.validFrom || !vm.validTo) {
                return false;
            }
            if (vm.validityDays <= 0) {
                return false;
            }
            return true;
        }

        function goBack() {
            $state.go('app.savings');
        }
    }
})();
